<div class="toolbar-wrapper">
  <div class="headerbar-title">
    <span class="title">{{ title() }}</span>
    <div class="headerbar-actions">
      <button
        class="notification-btn"
        [class.has-unread]="hasUnreadNotifications()"
        aria-label="Notificaciones"
        (click)="toggleNotifications($event)"
        [attr.aria-expanded]="notificationsOpen"
      >
        <span class="material-symbols-outlined notifications" aria-hidden="true">{{
          hasUnreadNotifications() ? 'notifications_unread' : 'notifications'
        }}</span>
      </button>
      <button
        class="account-btn"
        aria-label="Cuenta"
        (click)="toggleAccountPanel($event)"
        [attr.aria-expanded]="accountPanelOpen"
      >
        <span class="material-symbols-outlined account" aria-hidden="true">account_circle</span>
      </button>
    </div>
  </div>
  <div class="states" *ngIf="!isHome() && showSelectedEntityName()">
    <span class="company-name">{{ selectedEntityName() }}</span>
    <div class="state-group">
      <app-status-split-dropdown
        [status]="selectedEntityStatus()"
        [subStatusOptions]="statusDescriptions"
        [loading]="selectedEntityStatusLoading()"
        [disabled]="!showStatusDropdown"
        (subStatusChange)="selectStatusDescription($event)"
      />
    </div>
  </div>
</div>

@if (notificationsOpen) {
  <div
    #notificationsPanel
    class="notifications-panel-wrapper"
    role="dialog"
    aria-label="Notifications"
  >
    <app-notifications-panel
      [notifications]="notifications()"
      [loading]="notificationsLoading"
      (reviewStatusChange)="onReviewStatusChange($event)"
      (notificationClick)="onNotificationClick($event)"
    />
  </div>
}

<app-status-change-modal
  #statusChangeModal
  [isOpen]="showStatusChangeModal"
  [initialState]="statusChangeModalInitialState"
  [legalEntityName]="statusChangeModalData.legalEntityName"
  [currentStatus]="statusChangeModalData.currentStatus"
  [newStatus]="statusChangeModalData.newStatus"
  [alreadyProcessedBy]="statusChangeModalData.alreadyProcessedBy"
  (approve)="onApproveStatusChange()"
  (reject)="onRejectStatusChange()"
  (confirmChange)="onConfirmStatusChange()"
  (close)="closeStatusChangeModal()"
/>

@if (accountPanelOpen) {
  <div
    class="account-panel"
    role="dialog"
    aria-label="User info"
    (click)="$event.stopPropagation()"
  >
    <div class="account-panel__inner">
      <div class="user-initial" *ngIf="userFullName() as full">{{ full.charAt(0) }}</div>
      <div class="user-name">{{ userFullName() }}</div>
    </div>
  </div>
}
